// import React from "react";
// import { Target, ChartBar, Award, Users } from "lucide-react";

// export default function Mission() {
//   return (
//     <section className="py-20 bg-blue-900 text-white" id="mission">
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//         <div className="text-center">
//           {/* Icon Badge */}
//           <div className="flex justify-center mb-6">
//             <div className="bg-green-500 p-4 rounded-full">
//               <Target className="w-8 h-8" />
//             </div>
//           </div>

//           {/* Heading */}
//           <h2 className="text-3xl md:text-4xl font-bold mb-8">Our Mission</h2>

//           {/* Description */}
//           <p className="text-xl text-blue-100 max-w-4xl mx-auto leading-relaxed">
//             Our mission is to revolutionize dairy technology by delivering
//             cutting-edge milk testing equipment and software solutions that
//             enhance milk quality, farmer profitability, and dairy industry
//             efficiency. We strive to empower dairy businesses with smart
//             automation, real-time data management, and AI-driven analytics,
//             ensuring higher productivity, transparency, and sustainability in
//             milk processing and distribution.
//           </p>

//           {/* Icons Grid */}
//           <div className="mt-12 grid md:grid-cols-3 gap-8">
//             {/* Innovation */}
//             <div className="text-center">
//               <div className="bg-blue-800 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
//                 {/* <BarChart3 className="w-8 h-8" /> */}
//                 <ChartBar className="w-8 h-8 text-white" />
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Innovation</h3>
//               <p className="text-blue-200">
//                 Cutting-edge technology for dairy excellence
//               </p>
//             </div>

//             {/* Quality */}
//             <div className="text-center">
//               <div className="bg-blue-800 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
//                 <Award className="w-8 h-8" />
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Quality</h3>
//               <p className="text-blue-200">
//                 ISO-certified standards and reliability
//               </p>
//             </div>

//             {/* Partnership */}
//             <div className="text-center">
//               <div className="bg-blue-800 p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center">
//                 <Users className="w-8 h-8" />
//               </div>
//               <h3 className="text-xl font-semibold mb-2">Partnership</h3>
//               <p className="text-blue-200">
//                 Trusted partner for agricultural industry
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// components/Mission.jsx
import React from "react";
import { Target, ChartBar, Award, Users } from "lucide-react";
import { colors } from "../Color";

export default function Mission() {
  return (
    <section
      className="py-20"
      id="mission"
      style={{ backgroundColor: colors.secondary, color: colors.text }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          {/* Icon Badge */}
          <div className="flex justify-center mb-6">
            <div
              className="p-4 rounded-full"
              style={{ backgroundColor: colors.accent }}
            >
              <Target className="w-8 h-8 text-white" />
            </div>
          </div>

          {/* Heading */}
          <h2 className="text-3xl md:text-4xl font-bold mb-8">Our Mission</h2>

          {/* Description */}
          {/* <h3
            className="text-xl max-w-4xl mx-auto leading-relaxed"
            style={{ color: colors.background }}
          >
            Our mission is to revolutionize dairy technology by delivering
            cutting-edge milk testing equipment and software solutions that
            enhance milk quality, farmer profitability, and dairy industry
            efficiency. We strive to empower dairy businesses with smart
            automation, real-time data management, and AI-driven analytics,
            ensuring higher productivity, transparency, and sustainability in
            milk processing and distribution.
          </h3> */}
          <h3
            className="text-2xl md:text-3xl font-semibold mx-auto leading-relaxed w-full text-center"
            style={{ color: colors.background }}
          >
            Our mission is to revolutionize dairy technology by delivering
            cutting-edge milk testing equipment and software solutions that
            enhance milk quality, farmer profitability, and dairy industry
            efficiency. We strive to empower dairy businesses with smart
            automation, real-time data management, and AI-driven analytics,
            ensuring higher productivity, transparency, and sustainability in
            milk processing and distribution.
          </h3>
          {/* Icons Grid */}
          <div className="mt-12 grid md:grid-cols-3 gap-8">
            {/* Innovation */}
            <div className="text-center">
              <div
                className="p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: colors.primary }}
              >
                <ChartBar className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Innovation</h3>
              <p style={{ color: colors.background }}>
                Cutting-edge technology for dairy excellence
              </p>
            </div>

            {/* Quality */}
            <div className="text-center">
              <div
                className="p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: colors.primary }}
              >
                <Award className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Quality</h3>
              <p style={{ color: colors.background }}>
                ISO-certified standards and reliability
              </p>
            </div>

            {/* Partnership */}
            <div className="text-center">
              <div
                className="p-4 rounded-full w-16 h-16 mx-auto mb-4 flex items-center justify-center"
                style={{ backgroundColor: colors.primary }}
              >
                <Users className="w-8 h-8 text-white" />
              </div>
              <h3 className="text-xl font-semibold mb-2">Partnership</h3>
              <p style={{ color: colors.background }}>
                Trusted partner for agricultural industry
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
